export default __webpack_public_path__ + "static/team4-2a348f653bed05ec5bc8463f5aa4a5cb.jpg";